export enum ENROLMENT_STEP {
  CI_DOC_NUM = "CI_DOC_NUM",
  CLAVE_UNICA = "CLAVE_UNICA",
  QUESTIONS_CHALLENGE = "QUESTIONS_CHALLENGE",
  BANK_TRANSACTION_CHALLENGE = "BANK_TRANSACTION_CHALLENGE",
  CERTIFICATE = "CERTIFICATE",
}

export enum ENROLMENT_STEP_STATUS {
  NOT_STARTED = "NOT_STARTED",
  STARTED = "STARTED",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}
